<template>
  <template v-if="!report">
    <v-sheet class="d-flex justify-center align-center">
      <v-card :color="`#f6f6f6`" flat rounded="xl">
        <template v-slot:title>
          <div class="d-flex">
            <span class="font-weight-bold">Создать отчёт по выработке</span>
          </div>
        </template>
        <template v-slot:subtitle  v-if="!range || !selected">
          Для создания отчёта, необходимо выбрать
          <span v-if="!selected" class="font-weight-bold">ПОДРАЗДЕЛЕНИЕ</span>
          <span v-if="!range && !selected"><br>и </span>
          <span v-if="!range">
          отчётный <span class="font-weight-bold">ПЕРИОД</span>, <br v-if="!range && selected">за который вы хотите сформировать отчёт
        </span>
        </template>
        <template v-slot:text>
          <v-autocomplete
              v-if="!report && departments"
              density="compact"
              flat
              hide-details
              variant="solo"
              style="min-width: 300px"
              label="Подразделение"
              item-title="Department"
              item-value="Guid"
              :items="sortedDeps"
              v-model="selected"
              class="my-2"
          />
          <grdn-calendar v-model="range" range />
        </template>
        <template v-slot:actions>
          <v-btn block rounded="xl" v-if="range && selected" v-on:click="createReport()" variant="flat" color="light-green">
            <template v-slot:default>
              СФОРМИРОВАТЬ ОТЧЕТ
            </template>
          </v-btn>
          <v-btn v-else block rounded="xl" variant="plain" color="deep-orange" disabled>
            <template v-slot:default>
              НЕВОЗМОЖНО СФОРМИРОВАТЬ ОТЧЕТ
            </template>
          </v-btn>
        </template>
      </v-card>
    </v-sheet>
  </template>
  <template v-if="report">
    <v-card color="grey-lighten-2" rounded="xl" flat>
      <template v-slot:title>
        Результаты отчёта
      </template>
      <template v-slot:subtitle>
        c {{ moment(this.range.start).format('DD.MM.YYYY') }} по {{ moment(this.range.end).format('DD.MM.YYYY') }}

        <p v-if="final.hours && final.money">
          <span>За период</span> {{ final.hours }} ч/ч<br>
          <span>Cтоимость</span> {{ final.money }}₽
        </p>
      </template>
      <template v-slot:append>
        <v-tooltip text="СВЕРНУТЬ ВСЁ" location="start" v-if="oppened && oppened.length > 0">
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props" variant="plain" flat rounded="xl" class="ma-1" v-on:click="oppened = []" :icon="true">
              <v-icon :icon="['fas', 'angles-up']" fade />
            </v-btn>
          </template>
        </v-tooltip>

        <v-btn flat rounded="xl" class="ma-1" v-on:click="newReport()" :icon="true" :disabled="loading">
          <v-icon :icon="['fas', 'plus']" :beat-fade="loading"/>
        </v-btn>
        <v-btn flat rounded="xl" class="ma-1" v-on:click="!loading ? createReport() : null" v-if="selected && range" :icon="true" :disabled="loading">
          <v-icon :icon="['fas', 'rotate']" :spin="loading"/>
        </v-btn>
      </template>
    </v-card>
  </template>



  <v-expansion-panels v-model="oppened" multiple variant="popout" v-if="report && true" class="mt-2">
    <v-expansion-panel :value="user['GUID']" v-for="user of report" :key="user" rounded="xl" color="grey-lighten-2" class="zelopa" elevation="0" bg-color="grey-lighten-3">
      <template v-slot:title>
            <span :style="`color: ${user['Хороший'] ? colors.good.bg_colored : colors.bad.bg}`" class="mr-3">
              <v-icon v-if="user['Хороший']" :icon="['fas', 'circle-check']" />
              <v-icon v-else :icon="['fas', 'circle-exclamation']" />
            </span>
        <v-sheet color="transparent" :style="`color: ${user['Хороший'] ? colors.good.text_light : colors.good.text}`">
          <span v-for="(el, index) in getFormattedUser(user['Сотрудник'])" :key="index">
            <span :class="index === 0 ? 'font-weight-bold' : null">{{ el }}&nbsp;<br v-if="index === 0"></span>
          </span>
        </v-sheet>
      </template>
      <template v-slot:text>
        <v-card color="white" flat class="mb-2" rounded="xl" density="compact">
          <template v-slot:text>
            <v-sheet color="transparent" rounded="xl" flat class="d-flex justify-space-between align-center">
              <p>
                <span class="font-weight-bold">Ч/Ч за период</span> {{ user['ЧЧПериод'].value }}<br>
                <span class="font-weight-bold">Cтоимость ч/ч</span> {{ user['СтоимостьЧаса'].toFixed(2) }}₽
              </p>
              <v-spacer />
              <v-chip>
                <p><span class="font-weight-bold">Итого за период</span> {{ user['ЗлотыхЗаПериод'].value }}₽</p>
              </v-chip>
            </v-sheet>
          </template>
        </v-card>

        <v-expansion-panels multiple>
          <v-expansion-panel v-for="day of user['ДанныеПоДатам']" :key="day" rounded="xl" elevation="0">
            <template v-slot:title>
              <v-sheet v-if="!day['НаличиеЕжедневногоОтчёта']" class="mr-2">
                <v-chip :color="colors.bad.bg" class="font-weight-bold">
                  <v-icon :icon="['fas', 'clipboard-list']" />

                  <v-tooltip activator="parent">
                    Отсутствует ежедневный отчёт!
                  </v-tooltip>
                </v-chip>
              </v-sheet>
              <v-sheet v-if="!day['Хороший']">
                <v-chip :color="colors.bad.bg" class="font-weight-bold">{{ new Date(day['Дата']).toLocaleDateString() }} ВНИМАНИЕ</v-chip>
              </v-sheet>
              <v-sheet v-if="day['Хороший']">
                <v-chip>{{ new Date(day['Дата']).toLocaleDateString() }}</v-chip>
              </v-sheet>
              <v-spacer />
              <v-sheet color="transparent" class="pa-1 mr-5">
                <v-chip class="mb-1" density="compact" :color="day['ЧЧДень'].valid ? colors.good.bg : colors.bad.bg">
                  <span :style="`color: ${day['ЧЧДень'].valid ? colors.good.text : colors.bad.bg}`">{{ day['ЧЧДень'].value.toFixed(2) }} ч/ч</span>
                </v-chip>
                <br>
                <v-chip density="compact">
                  {{ day['СуммаЗаДень'].value.toFixed(2) }} ₽
                </v-chip>
              </v-sheet>
            </template>
            <template v-slot:text>
              <v-table>
                <thead>
                <tr>
                  <th class="text-left">
                    Тип документа
                  </th>
                  <th class="text-left">
                    Номер
                  </th>
                  <th class="text-left">
                    Тип работ
                  </th>
                  <th class="text-left">
                    Физ. объект
                  </th>
                  <th class="text-left">
                    Общая трудоёмкость (План)
                  </th>
                  <th class="text-left">
                    Общие трудоёмкость (Факт)
                  </th>
                  <th class="text-left">
                    Трудозатраты сотрудника за период
                  </th>
                  <th class="text-left">
                    Время начала
                  </th>
                  <th class="text-left">
                    Время окончания
                  </th>
                  <th class="text-left">
                    К начислению (₽)<br>
                    (Получено на руки)
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="document in sorted(day['Данные'])" :key="document" :style="`background: ${ document['Хороший'] ? colors.good.bg : colors.bad.light_bg }`">
                  <template v-if="document['ТипДокумента'].value === 'Обращение'">
                    <td>Обращение</td>
                    <td>{{ document['Номер'].value }}</td>
                    <td>{{ document['ТипРабот'].value }}</td>
                    <td>{{ document['ФизическийОбъектОбсл'].value }}</td>
                    <td></td>
                    <td :style="`color: ${document['ФактическаяТрудоемкость'].valid ? colors.good.text : colors.bad.bg }`">{{ document['ФактическаяТрудоемкость'].value.toFixed(2) }}</td>
                    <td :style="`color: ${document['ФактическоеВремя'].valid ? colors.good.text : colors.bad.bg }`">{{ document['ФактическоеВремя'].value.toFixed(2) }}</td>
                    <td>{{ moment(document['ВремяНачала'].value).format('HH:mm:ss') }}</td>
                    <td>{{ moment(document['ВремяОкончания'].value).format('HH:mm:ss') }}</td>
                    <td :style="`color: ${document['СуммаНаРуки'].valid ? colors.good.text : colors.bad.bg }`">{{ document['СуммаНаРуки'].value.toFixed(2) }}</td>
                  </template>
                  <template v-if="document['ТипДокумента'].value === 'ПроведениеТОППР'">
                    <td>ТОиППР</td>
                    <td>{{ document['Номер'].value }}</td>
                    <td>{{ document['ТипРабот'].value }}</td>
                    <td>{{ document['ФизическийОбъектОбсл'].value }}</td>
                    <td :style="`color: ${document['ПлановаяТрудоемкость'].valid ? colors.good.text : colors.bad.bg }`">{{ document['ПлановаяТрудоемкость'].value.toFixed(2) }}</td>
                    <td :style="`color: ${document['ФактическаяТрудоемкость'].valid ? colors.good.text : colors.bad.bg }`">{{ document['ФактическаяТрудоемкость'].value.toFixed(2) }}</td>
                    <td :style="`color: ${document['ФактическоеВремя'].valid ? colors.good.text : colors.bad.bg }`">{{ document['ФактическоеВремя'].value.toFixed(2) }}</td>
                    <td>{{ moment(document['ВремяНачала'].value).format('HH:mm:ss') }}</td>
                    <td>{{ moment(document['ВремяОкончания'].value).format('HH:mm:ss') }}</td>
                    <td :style="`color: ${document['СуммаНаРуки'].valid ? colors.good.text : colors.bad.bg }`">{{ document['СуммаНаРуки'].value.toFixed(2) }}</td>
                  </template>
                  <template v-if="document['ТипДокумента'].value === 'ЕжедневныйОтчет'">
                    <td>Ежедневный отчёт</td>
                    <td>{{ document['Номер'].value }}</td>
                    <td>{{ document['ТипРабот'].value }}</td>
                    <td>{{ document['ФизическийОбъектОбсл'].value }}</td>
                    <td></td>
                    <td></td>
                    <td :style="`color: ${document['ФактическоеВремя'].valid ? colors.good.text : colors.bad.bg }`">{{ document['ФактическоеВремя'].value.toFixed(2) }}</td>
                    <td>{{ moment(document['ВремяНачала'].value).format('HH:mm:ss') }}</td>
                    <td>{{ moment(document['ВремяОкончания'].value).format('HH:mm:ss') }}</td>
                    <td :style="`color: ${document['СуммаНаРуки'].valid ? colors.good.text : colors.bad.bg }`">{{ document['СуммаНаРуки'].value.toFixed(2) }}</td>
                  </template>
                  <template v-if="document['ТипДокумента'].value === 'Дежурство'">
                    <td>Дежурство</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{{ document['ФактическоеВремя'].value }}</td>
                    <td></td>
                    <td></td>
                    <td>{{ document['СуммаНаРуки'].value }}</td>
                  </template>
                </tr>
                <tr>
                  <td colspan="7" />
                  <td class="text-right font-weight-bold" colspan="2">
                    Сумма на руки:
                  </td>
                  <td class="font-weight-bold" :style="`color: ${day['СуммаЗаДень'].valid ? colors.good.text : colors.bad.bg }`">
                    {{ day['СуммаЗаДень'].value }}
                  </td>
                </tr>
                <tr>
                  <td colspan="7" />
                  <td class="text-right font-weight-bold" colspan="2">
                    Предварительно:
                  </td>
                  <td class="font-weight-bold" :style="`color: ${day['СуммаЗаДень_ПЛАН'].valid ? colors.good.text : colors.bad.bg }`">
                    {{ day['СуммаЗаДень_ПЛАН'].value }}
                  </td>
                </tr>
                </tbody>
              </v-table>
            </template>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { TokenGUIDStore } from "@/store/global/SessionStore";
import { ErrorStore } from "@/store/ErrorStore";
import { departments, report_dep, selected_dep, selected_range } from "@/store/Dashboard/productivity";
import moment from "moment";
import route_check from "@/libs/route_check";
import GrdnCalendar from "@/components/grdn/grdn-calendar.vue";

export default {
  name: "ProductivityApp",
  components: { GrdnCalendar },
  async beforeMount() {
    route_check('/dashboard/productivity').then(async res => {
      if (res) {
        await this.getProductionSectorList()
      } else {
        this.$router.push({ name: 'home' })
      }
    })
  },
  data() {
    return {
      final: {
        money: null,
        hours: null
      },
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
      oppened: [],
      loading: false,
      calendar: {
        rules: [
          {
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0,
          },
          {
            hours: 23,
            minutes: 59,
            seconds: 59,
            milliseconds: 999,
          }
        ]
      },
      colors: {
        good: {
          text: '#000000',
          text_light: '#d9d9d9',
          bg: '#ffffff',
          bg_colored: '#C5E1A5'
        },
        bad: {
          text: '#ffffff',
          light_bg: '#FFCCBC',
          bg: '#FF5722'
        }
      }
    }
  },
  computed: {
    sortedDeps() {
      return this.departments.slice(0).sort((a,b) => (a.Department > b.Department) ? 1 : ((b.Department > a.Department) ? -1 : 0))
    },
    preparedData() {
      return {
        department: this.selected,
        dateStart: moment(this.range.start).format('YYYY-MM-DD[T]00:00:00.000Z'),
        dateEnd: moment(this.range.end).format('YYYY-MM-DD[T]23:59:59.999Z'),
      }
    },
    errors: {
      get() {
        return ErrorStore().get()
      },
      set(value) {
        ErrorStore().set(value)
      }
    },
    report: {
      get() {
        return report_dep().get()
      },
      set(value) {
        report_dep().set(value)
      }
    },
    range: {
      get() {
        return selected_range().get()
      },
      set(value) {
        selected_range().set(value)
      }
    },
    departments: {
      get() {
        return departments().get()
      },
      set(value) {
        departments().set(value)
      }
    },
    selected: {
      get() {
        return selected_dep().get()
      },
      set(value) {
        selected_dep().set(value)
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    }
  },
  methods: {
    sorted: function (array) {
      console.log(array)
      return array.sort(function(a, b) {
        return moment(a['ВремяНачала'].value).format('x') - moment(b['ВремяНачала'].value).format('x');
      });
    },
    moment,
    select_date: function (period) {
      switch (period) {
        case 'today':
          this.range = {
            start: moment().format('YYYY-MM-DD[T]00:00:00.000Z'),
            end: moment().format('YYYY-MM-DD[T]23:59:59.999Z')
          }
          break;
        case 'tomorrow':
          this.range = {
            start: moment().subtract(1, 'days').format('YYYY-MM-DD[T]00:00:00.000Z'),
            end: moment().subtract(1, 'days').format('YYYY-MM-DD[T]23:59:59.999Z')
          }
          break;
        case 'last_week':
          this.range = {
            start: moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD[T]00:00:00.000Z'),
            end: moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD[T]23:59:59.999Z')
          }
          break;
        case 'prev_month':
          this.range = {
            start: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD[T]00:00:00.000Z'),
            end: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD[T]23:59:59.999Z')
          }
          break;
        default:
          break;
      }
    },
    check_color: function (period) {
      if (this.range) {
        switch (period) {
          case 'today':
            if (
                moment(this.range.start).format('YYYY-MM-DD[T]00:00:00.000Z') === moment().format('YYYY-MM-DD[T]00:00:00.000Z')
                &&
                moment(this.range.end).format('YYYY-MM-DD[T]23:59:59.999Z') === moment().format('YYYY-MM-DD[T]23:59:59.999Z')
            ) return true
            return false
          case 'tomorrow':
            if (
                moment(this.range.start).format('YYYY-MM-DD[T]00:00:00.000Z') === moment().subtract(1, 'days').format('YYYY-MM-DD[T]00:00:00.000Z')
                &&
                moment(this.range.end).format('YYYY-MM-DD[T]23:59:59.999Z') === moment().subtract(1, 'days').format('YYYY-MM-DD[T]23:59:59.999Z')
            ) return true
            return false
          case 'last_week':
            if (
                moment(this.range.start).format('YYYY-MM-DD[T]00:00:00.000Z') === moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD[T]00:00:00.000Z')
                &&
                moment(this.range.end).format('YYYY-MM-DD[T]23:59:59.999Z') === moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD[T]23:59:59.999Z')
            ) return true
            return false
          case 'prev_month':
            if (
                moment(this.range.start).format('YYYY-MM-DD[T]00:00:00.000Z') === moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD[T]00:00:00.000Z')
                &&
                moment(this.range.end).format('YYYY-MM-DD[T]23:59:59.999Z') === moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD[T]23:59:59.999Z')
            ) return true
            return false
          default:
            return false
        }
      } else {
        return false
      }
    },
    getFormattedUser: function (user) {
      let u = []
      if (user && user !== null) {
        let user_words = user.split(' ')
        u.push(user_words[0].toUpperCase())
        for (let i = 1; i < user_words.length; i++) {
          u.push(user_words[i])
        }
      } else {
        console.log(`Не верный формат ФИО: ${user}`)
        u.push(`?`)
      }
      return u
    },
    newReport: function () {
      this.report = null
      this.range = null
    },
    dailyHours: function (day) {
      let hours = 0
      if (day['Данные'].length > 0) {
        for (let doc of day['Данные']) {
          if (doc['ТипДокумента'].value !== 'Дежурство') {
            hours += doc['ФактическоеВремя'].value
          }
        }
      }
      return {
        value: parseFloat(hours.toFixed(2)),
        valid: hours > 7 ? true : false
      }
    },
    dailyMoney: function (day, hh) {
      let money = 0
      if (day['Данные'].length > 0) {
        for (let doc of day['Данные']) {
          money += doc['СуммаНаРуки'].value
        }
      }
      let hhMoney_without_duty = this.dailyHours(day).value * hh
      let hhMoney_duty = this.dailyDutys(day)
      let hhMoney = hhMoney_without_duty + hhMoney_duty

      let procent
      if (hhMoney > money) {
        procent = (hhMoney - money) / hhMoney * 100
      } else if (hhMoney < money) {
        procent = (money - hhMoney) / hhMoney * 100
      } else {
        procent = 0
      }
      let isValid = Math.abs(procent) <= 10 && money > 0 ? true : false
      return {
        value: parseFloat(money.toFixed(2)),
        valid: isValid
      }
    },
    dailyDutys: function (day) {
      let mms = 0
      if (day['Данные'].length > 0) {
        for (let doc of day['Данные']) {
          if (doc['ТипДокумента'].value === 'Дежурство') {
            mms += doc['СуммаНаРуки'].value
          }
        }
      }
      return mms
    },
    dailyMoney_Planned: function (day, hh) {
      let hhMoney_without_duty = this.dailyHours(day).value * hh
      let hhMoney_duty = this.dailyDutys(day)

      let hhMoney = hhMoney_without_duty + hhMoney_duty
      return {
        value: parseFloat(hhMoney.toFixed(2)),
        valid: true
      }
    },
    checkField: function (field, day, document) {
      switch (field) {
        case 'Номер':
        case 'Дата':
        case 'ТипРабот':
        case 'ТипРабот_GUID':
        case 'ФизическийОбъектОбсл':
        case 'ФизическийОбъектОбсл_GUID':
        case 'ТипДокумента':
        case 'Сотрудник':
        case 'ФактическоеВремя':
        case 'ВремяНачала':
        case 'ВремяОкончания':
        case 'СтоимостьЧаса':
          return true
        case 'ПлановаяТрудоемкость':
          if (document['ТипДокумента'] === 'ПроведениеТОППР') {
            if (document[field] > 0) return true
            return false
          } else {
            return true
          }
        case 'ФактическаяТрудоемкость':
          if (document['ТипДокумента'] === 'ПроведениеТОППР') {
            let min_15proc = document[field] * 0.75
            let max_15proc = document[field] * 1.15
            if (document[field] < max_15proc && document[field] > min_15proc) return true
            return false
          } else {
            return true
          }
        case 'КоэффициентЭффективности':
          if (document['ТипДокумента'] === 'Обращение') {
            if (document[field] >= 1) return true
            return false
          } else if (document['ТипДокумента'] === 'ПроведениеТОППР') {
            if (document[field] > 0) return true
            return false
          } else {
            return true
          }
        case 'СуммаНаРуки':
          if (document[field] > 0) return true
          return false
        default:
          return false
      }
    },
    createReport: async function () {
      this.final = {
        money: null,
        hours: null
      }
      this.report = []
      this.loading = true
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/GetDataTimeIZP`
      let body = JSON.stringify(this.preparedData)
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: body
      }
      await fetch(url, properies)
          .then(response => response.text())
          .then(result => {
            let report = JSON.parse(result)
            console.log(report)
            // Обрабатываем каждый день
            for (let human of report) {
              for (let day of human['ДанныеПоДатам']) {
                for (let document of day['Данные']) {
                  let fields = Object.keys(document)
                  for (let field of fields) {
                    if (document[field] !== null) {
                      document[field] = {
                        value: document[field],
                        valid: this.checkField(field, day, document)
                      }
                    } else {
                      document[field] = null
                    }
                  }
                  document['Хороший'] = this.isGoodDocument(document)
                }
                day['ЧЧДень'] = this.dailyHours(day)
                day['СуммаЗаДень'] = this.dailyMoney(day, human['СтоимостьЧаса'])
                day['СуммаЗаДень_ПЛАН'] = this.dailyMoney_Planned(day, human['СтоимостьЧаса'])
                day['Хороший'] = this.isGoodDay(day)
              }
              human['ЗлотыхЗаПериод'] = this.periodlyMoney(human)
              human['ЧЧПериод'] = this.periodlyHH(human)
              human['Хороший'] = this.goodPeriod(human)
              this.final.money += human['ЗлотыхЗаПериод'].value
              this.final.hours += human['ЧЧПериод'].value
            }

            for (let human of report) {
              human['ДанныеПоДатам'] = human['ДанныеПоДатам'].sort(function(a,b){
                return new Date(b['Дата']) - new Date(a['Дата']);
              })
            }

            this.final.money = this.final.money.toFixed(2)
            this.final.hours = this.final.hours.toFixed(2)

            this.report = report
          })
          .finally(() => {
            this.loading = false
          }).catch((err) => {
            console.log('Ошибка формирования отчёта...')
            console.warn(err)
          })
    },
    goodPeriod: function (human) {
      let isGood = true
      for (let day of human['ДанныеПоДатам']) {
        if (day['Хороший'] === false) {
          isGood = false
        }
      }
      return isGood
    },
    periodlyHH: function (human) {
      let hhs = 0
      for (let day of human['ДанныеПоДатам']) {
        hhs += day['ЧЧДень'].value
      }
      return {
        value: parseFloat(hhs.toFixed(2)),
        valid: true
      }
    },
    isGoodDocument: function (document) {
      let isGood = true
      let fields = Object.keys(document)
      for (let field of fields) {
        if (document[field]) {
          if (document[field].valid === false) {
            isGood = false
          }
        }
      }
      return isGood
    },
    isGoodDay: function (day) {
      let isGood = true
      for (let doc of day['Данные']) {
        if (doc['Хороший'] === false) {
          isGood = false
        }
      }
      if (!day['ЧЧДень'].valid) {
        isGood = false
      }
      if (!day['СуммаЗаДень'].valid) {
        isGood = false
      }
      if (!day['НаличиеЕжедневногоОтчёта']) {
        isGood = false
      }
      return isGood
    },
    periodlyMoney: function (human) {
      let money = 0
      if (human['ДанныеПоДатам'].length > 0) {
        for (let day of human['ДанныеПоДатам']) {
          money += day['СуммаЗаДень'].value
        }
      }
      return {
        value: parseFloat(money.toFixed(2)),
        valid: money > 0 ? true : false
      }
    },
    getProductionSectorList: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/GetDepartment`
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        }
      }
      console.log('Получаю список производственных участков...')
      await fetch(url, properies)
          .then(response => response.text())
          .then(result => {
            console.log('Успешно!')
            this.departments = JSON.parse(result)
          }).catch((err) => {
            this.errors.push({type: 'one_error', error: 'Ошибка получения списка производственных участков...'})
            console.log('Ошибка получения данных...')
            console.warn(err)
          })
    }
  }
}
</script>


<style scoped>
.zepoper {
  background-color: #FFFFFF;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='985' height='492.5' viewBox='0 0 1600 800'%3E%3Cpath fill='%23FFA588' d='M1102.5 734.8c2.5-1.2 24.8-8.6 25.6-7.5.5.7-3.9 23.8-4.6 24.5C1123.3 752.1 1107.5 739.5 1102.5 734.8zM1226.3 229.1c0-.1-4.9-9.4-7-14.2-.1-.3-.3-1.1-.4-1.6-.1-.4-.3-.7-.6-.9-.3-.2-.6-.1-.8.1l-13.1 12.3c0 0 0 0 0 0-.2.2-.3.5-.4.8 0 .3 0 .7.2 1 .1.1 1.4 2.5 2.1 3.6 2.4 3.7 6.5 12.1 6.5 12.2.2.3.4.5.7.6.3 0 .5-.1.7-.3 0 0 1.8-2.5 2.7-3.6 1.5-1.6 3-3.2 4.6-4.7 1.2-1.2 1.6-1.4 2.1-1.6.5-.3 1.1-.5 2.5-1.9C1226.5 230.4 1226.6 229.6 1226.3 229.1zM33 770.3C33 770.3 33 770.3 33 770.3c0-.7-.5-1.2-1.2-1.2-.1 0-.3 0-.4.1-1.6.2-14.3.1-22.2 0-.3 0-.6.1-.9.4-.2.2-.4.5-.4.9 0 .2 0 4.9.1 5.9l.4 13.6c0 .3.2.6.4.9.2.2.5.3.8.3 0 0 .1 0 .1 0 7.3-.7 14.7-.9 22-.6.3 0 .7-.1.9-.3.2-.2.4-.6.4-.9C32.9 783.3 32.9 776.2 33 770.3z'/%3E%3Cpath fill='%23C5C5C5' d='M171.1 383.4c1.3-2.5 14.3-22 15.6-21.6.8.3 11.5 21.2 11.5 22.1C198.1 384.2 177.9 384 171.1 383.4zM596.4 711.8c-.1-.1-6.7-8.2-9.7-12.5-.2-.3-.5-1-.7-1.5-.2-.4-.4-.7-.7-.8-.3-.1-.6 0-.8.3L574 712c0 0 0 0 0 0-.2.2-.2.5-.2.9 0 .3.2.7.4.9.1.1 1.8 2.2 2.8 3.1 3.1 3.1 8.8 10.5 8.9 10.6.2.3.5.4.8.4.3 0 .5-.2.6-.5 0 0 1.2-2.8 2-4.1 1.1-1.9 2.3-3.7 3.5-5.5.9-1.4 1.3-1.7 1.7-2 .5-.4 1-.7 2.1-2.4C596.9 713.1 596.8 712.3 596.4 711.8zM727.5 179.9C727.5 179.9 727.5 179.9 727.5 179.9c.6.2 1.3-.2 1.4-.8 0-.1 0-.2 0-.4.2-1.4 2.8-12.6 4.5-19.5.1-.3 0-.6-.2-.8-.2-.3-.5-.4-.8-.5-.2 0-4.7-1.1-5.7-1.3l-13.4-2.7c-.3-.1-.7 0-.9.2-.2.2-.4.4-.5.6 0 0 0 .1 0 .1-.8 6.5-2.2 13.1-3.9 19.4-.1.3 0 .6.2.9.2.3.5.4.8.5C714.8 176.9 721.7 178.5 727.5 179.9zM728.5 178.1c-.1-.1-.2-.2-.4-.2C728.3 177.9 728.4 178 728.5 178.1z'/%3E%3Cg fill-opacity='0.13' fill='%23FFF'%3E%3Cpath d='M699.6 472.7c-1.5 0-2.8-.8-3.5-2.3-.8-1.9 0-4.2 1.9-5 3.7-1.6 6.8-4.7 8.4-8.5 1.6-3.8 1.7-8.1.2-11.9-.3-.9-.8-1.8-1.2-2.8-.8-1.7-1.8-3.7-2.3-5.9-.9-4.1-.2-8.6 2-12.8 1.7-3.1 4.1-6.1 7.6-9.1 1.6-1.4 4-1.2 5.3.4 1.4 1.6 1.2 4-.4 5.3-2.8 2.5-4.7 4.7-5.9 7-1.4 2.6-1.9 5.3-1.3 7.6.3 1.4 1 2.8 1.7 4.3.5 1.1 1 2.2 1.5 3.3 2.1 5.6 2 12-.3 17.6-2.3 5.5-6.8 10.1-12.3 12.5C700.6 472.6 700.1 472.7 699.6 472.7zM740.4 421.4c1.5-.2 3 .5 3.8 1.9 1.1 1.8.4 4.2-1.4 5.3-3.7 2.1-6.4 5.6-7.6 9.5-1.2 4-.8 8.4 1.1 12.1.4.9 1 1.7 1.6 2.7 1 1.7 2.2 3.5 3 5.7 1.4 4 1.2 8.7-.6 13.2-1.4 3.4-3.5 6.6-6.8 10.1-1.5 1.6-3.9 1.7-5.5.2-1.6-1.4-1.7-3.9-.2-5.4 2.6-2.8 4.3-5.3 5.3-7.7 1.1-2.8 1.3-5.6.5-7.9-.5-1.3-1.3-2.7-2.2-4.1-.6-1-1.3-2.1-1.9-3.2-2.8-5.4-3.4-11.9-1.7-17.8 1.8-5.9 5.8-11 11.2-14C739.4 421.6 739.9 421.4 740.4 421.4zM261.3 590.9c5.7 6.8 9 15.7 9.4 22.4.5 7.3-2.4 16.4-10.2 20.4-3 1.5-6.7 2.2-11.2 2.2-7.9-.1-12.9-2.9-15.4-8.4-2.1-4.7-2.3-11.4 1.8-15.9 3.2-3.5 7.8-4.1 11.2-1.6 1.2.9 1.5 2.7.6 3.9-.9 1.2-2.7 1.5-3.9.6-1.8-1.3-3.6.6-3.8.8-2.4 2.6-2.1 7-.8 9.9 1.5 3.4 4.7 5 10.4 5.1 3.6 0 6.4-.5 8.6-1.6 4.7-2.4 7.7-8.6 7.2-15-.5-7.3-5.3-18.2-13-23.9-4.2-3.1-8.5-4.1-12.9-3.1-3.1.7-6.2 2.4-9.7 5-6.6 5.1-11.7 11.8-14.2 19-2.7 7.7-2.1 15.8 1.9 23.9.7 1.4.1 3.1-1.3 3.7-1.4.7-3.1.1-3.7-1.3-4.6-9.4-5.4-19.2-2.2-28.2 2.9-8.2 8.6-15.9 16.1-21.6 4.1-3.1 8-5.1 11.8-6 6-1.4 12 0 17.5 4C257.6 586.9 259.6 588.8 261.3 590.9z'/%3E%3Ccircle cx='1013.7' cy='153.9' r='7.1'/%3E%3Ccircle cx='1024.3' cy='132.1' r='7.1'/%3E%3Ccircle cx='1037.3' cy='148.9' r='7.1'/%3E%3Cpath d='M1508.7 297.2c-4.8-5.4-9.7-10.8-14.8-16.2 5.6-5.6 11.1-11.5 15.6-18.2 1.2-1.7.7-4.1-1-5.2-1.7-1.2-4.1-.7-5.2 1-4.2 6.2-9.1 11.6-14.5 16.9-4.8-5-9.7-10-14.7-14.9-1.5-1.5-3.9-1.5-5.3 0-1.5 1.5-1.5 3.9 0 5.3 4.9 4.8 9.7 9.8 14.5 14.8-1.1 1.1-2.3 2.2-3.5 3.2-4.1 3.8-8.4 7.8-12.4 12-1.4 1.5-1.4 3.8 0 5.3 0 0 0 0 0 0 1.5 1.4 3.9 1.4 5.3-.1 3.9-4 8.1-7.9 12.1-11.7 1.2-1.1 2.3-2.2 3.5-3.3 4.9 5.3 9.8 10.6 14.6 15.9.1.1.1.1.2.2 1.4 1.4 3.7 1.5 5.2.2C1510 301.2 1510.1 298.8 1508.7 297.2zM327.6 248.6l-.4-2.6c-1.5-11.1-2.2-23.2-2.3-37 0-5.5 0-11.5.2-18.5 0-.7 0-1.5 0-2.3 0-5 0-11.2 3.9-13.5 2.2-1.3 5.1-1 8.5.9 5.7 3.1 13.2 8.7 17.5 14.9 5.5 7.8 7.3 16.9 5 25.7-3.2 12.3-15 31-30 32.1L327.6 248.6zM332.1 179.2c-.2 0-.3 0-.4.1-.1.1-.7.5-1.1 2.7-.3 1.9-.3 4.2-.3 6.3 0 .8 0 1.7 0 2.4-.2 6.9-.2 12.8-.2 18.3.1 12.5.7 23.5 2 33.7 11-2.7 20.4-18.1 23-27.8 1.9-7.2.4-14.8-4.2-21.3l0 0C347 188.1 340 183 335 180.3 333.6 179.5 332.6 179.2 332.1 179.2zM516.3 60.8c-.1 0-.2 0-.4-.1-2.4-.7-4-.9-6.7-.7-.7 0-1.3-.5-1.4-1.2 0-.7.5-1.3 1.2-1.4 3.1-.2 4.9 0 7.6.8.7.2 1.1.9.9 1.6C517.3 60.4 516.8 60.8 516.3 60.8zM506.1 70.5c-.5 0-1-.3-1.2-.8-.8-2.1-1.2-4.3-1.3-6.6 0-.7.5-1.3 1.2-1.3.7 0 1.3.5 1.3 1.2.1 2 .5 3.9 1.1 5.8.2.7-.1 1.4-.8 1.6C506.4 70.5 506.2 70.5 506.1 70.5zM494.1 64.4c-.4 0-.8-.2-1-.5-.4-.6-.3-1.4.2-1.8 1.8-1.4 3.7-2.6 5.8-3.6.6-.3 1.4 0 1.7.6.3.6 0 1.4-.6 1.7-1.9.9-3.7 2-5.3 3.3C494.7 64.3 494.4 64.4 494.1 64.4zM500.5 55.3c-.5 0-.9-.3-1.2-.7-.5-1-1.2-1.9-2.4-3.4-.3-.4-.7-.9-1.1-1.4-.4-.6-.3-1.4.2-1.8.6-.4 1.4-.3 1.8.2.4.5.8 1 1.1 1.4 1.3 1.6 2.1 2.6 2.7 3.9.3.6 0 1.4-.6 1.7C500.9 55.3 500.7 55.3 500.5 55.3zM506.7 55c-.3 0-.5-.1-.8-.2-.6-.4-.7-1.2-.3-1.8 1.2-1.7 2.3-3.4 3.3-5.2.3-.6 1.1-.9 1.7-.5.6.3.9 1.1.5 1.7-1 1.9-2.2 3.8-3.5 5.6C507.4 54.8 507.1 55 506.7 55zM1029.3 382.8c-.1 0-.2 0-.4-.1-2.4-.7-4-.9-6.7-.7-.7 0-1.3-.5-1.4-1.2 0-.7.5-1.3 1.2-1.4 3.1-.2 4.9 0 7.6.8.7.2 1.1.9.9 1.6C1030.3 382.4 1029.8 382.8 1029.3 382.8zM1019.1 392.5c-.5 0-1-.3-1.2-.8-.8-2.1-1.2-4.3-1.3-6.6 0-.7.5-1.3 1.2-1.3.7 0 1.3.5 1.3 1.2.1 2 .5 3.9 1.1 5.8.2.7-.1 1.4-.8 1.6C1019.4 392.5 1019.2 392.5 1019.1 392.5zM1007.1 386.4c-.4 0-.8-.2-1-.5-.4-.6-.3-1.4.2-1.8 1.8-1.4 3.7-2.6 5.8-3.6.6-.3 1.4 0 1.7.6.3.6 0 1.4-.6 1.7-1.9.9-3.7 2-5.3 3.3C1007.7 386.3 1007.4 386.4 1007.1 386.4zM1013.5 377.3c-.5 0-.9-.3-1.2-.7-.5-1-1.2-1.9-2.4-3.4-.3-.4-.7-.9-1.1-1.4-.4-.6-.3-1.4.2-1.8.6-.4 1.4-.3 1.8.2.4.5.8 1 1.1 1.4 1.3 1.6 2.1 2.6 2.7 3.9.3.6 0 1.4-.6 1.7C1013.9 377.3 1013.7 377.3 1013.5 377.3zM1019.7 377c-.3 0-.5-.1-.8-.2-.6-.4-.7-1.2-.3-1.8 1.2-1.7 2.3-3.4 3.3-5.2.3-.6 1.1-.9 1.7-.5.6.3.9 1.1.5 1.7-1 1.9-2.2 3.8-3.5 5.6C1020.4 376.8 1020.1 377 1019.7 377zM1329.7 573.4c-1.4 0-2.9-.2-4.5-.7-8.4-2.7-16.6-12.7-18.7-20-.4-1.4-.7-2.9-.9-4.4-8.1 3.3-15.5 10.6-15.4 21 0 1.5-1.2 2.7-2.7 2.8 0 0 0 0 0 0-1.5 0-2.7-1.2-2.7-2.7-.1-6.7 2.4-12.9 7-18 3.6-4 8.4-7.1 13.7-8.8.5-6.5 3.1-12.9 7.4-17.4 7-7.4 18.2-8.9 27.3-10.1l.7-.1c1.5-.2 2.9.9 3.1 2.3.2 1.5-.9 2.9-2.3 3.1l-.7.1c-8.6 1.2-18.4 2.5-24 8.4-3 3.2-5 7.7-5.7 12.4 7.9-1 17.7 1.3 24.3 5.7 4.3 2.9 7.1 7.8 7.2 12.7.2 4.3-1.7 8.3-5.2 11.1C1335.2 572.4 1332.6 573.4 1329.7 573.4zM1311 546.7c.1 1.5.4 3 .8 4.4 1.7 5.8 8.7 14.2 15.1 16.3 2.8.9 5.1.5 7.2-1.1 2.7-2.1 3.2-4.8 3.1-6.6-.1-3.2-2-6.4-4.8-8.3C1326.7 547.5 1317.7 545.6 1311 546.7z'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
}
.zelopa {
  background-color: #FFFFFF;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cdefs%3E%3CradialGradient id='a' cx='500' cy='500' r='60%25' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23FFFFFF'/%3E%3Cstop offset='1' stop-color='%23999999'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='500' cy='500' r='70%25' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23FFFFFF' stop-opacity='1'/%3E%3Cstop offset='1' stop-color='%23FFFFFF' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='url(%23a)' width='1000' height='1000'/%3E%3Cg fill='none' stroke='%23ADADAD' stroke-width='2' stroke-miterlimit='10' stroke-opacity='.5'%3E%3Ccircle cx='500' cy='500' r='725'/%3E%3Ccircle cx='500' cy='500' r='700'/%3E%3Ccircle cx='500' cy='500' r='675'/%3E%3Ccircle cx='500' cy='500' r='650'/%3E%3Ccircle cx='500' cy='500' r='625'/%3E%3Ccircle cx='500' cy='500' r='600'/%3E%3Ccircle cx='500' cy='500' r='575'/%3E%3Ccircle cx='500' cy='500' r='550'/%3E%3Ccircle cx='500' cy='500' r='525'/%3E%3Ccircle cx='500' cy='500' r='500'/%3E%3Ccircle cx='500' cy='500' r='475'/%3E%3Ccircle cx='500' cy='500' r='450'/%3E%3Ccircle cx='500' cy='500' r='425'/%3E%3Ccircle cx='500' cy='500' r='400'/%3E%3Ccircle cx='500' cy='500' r='375'/%3E%3Ccircle cx='500' cy='500' r='350'/%3E%3Ccircle cx='500' cy='500' r='325'/%3E%3Ccircle cx='500' cy='500' r='300'/%3E%3Ccircle cx='500' cy='500' r='275'/%3E%3Ccircle cx='500' cy='500' r='250'/%3E%3Ccircle cx='500' cy='500' r='225'/%3E%3Ccircle cx='500' cy='500' r='200'/%3E%3Ccircle cx='500' cy='500' r='175'/%3E%3Ccircle cx='500' cy='500' r='150'/%3E%3Ccircle cx='500' cy='500' r='125'/%3E%3Ccircle cx='500' cy='500' r='100'/%3E%3Ccircle cx='500' cy='500' r='75'/%3E%3Ccircle cx='500' cy='500' r='50'/%3E%3Ccircle cx='500' cy='500' r='25'/%3E%3C/g%3E%3Crect fill-opacity='.5' fill='url(%23b)' width='1000' height='1000'/%3E %3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
</style>
